import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createSafeContext } from '@mantine/utils';
import { TABS_ERRORS } from './Tabs.errors.js';

var _createSafeContext = createSafeContext(TABS_ERRORS.context),
    _createSafeContext2 = _slicedToArray(_createSafeContext, 2),
    TabsContextProvider = _createSafeContext2[0],
    useTabsContext = _createSafeContext2[1];

export { TabsContextProvider, useTabsContext };